import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
const [isAuthenticated, setIsAuthenticated] = useState(() => {
  return !!localStorage.getItem('token');
});

const [role, setRole] = useState(() => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user).role : null;
});

  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('user');
    return saved ? JSON.parse(saved) : null;
  });

const login = (userRole, userData = null, token = null) => {
  if (token) {
    localStorage.setItem("token", token);
  }

  if (userData) {
    localStorage.setItem("user", JSON.stringify(userData));
  }

  setIsAuthenticated(true);
 setRole(userData?.role);
  setUser(userData);
};

const logout = async () => {
  try {
    const token = localStorage.getItem('token');
    if (token) {
      await fetch(`${process.env.REACT_APP_BASE_API_URL}/api/logout`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
    }
  } catch (error) {
    console.error("Logout API failed", error);
  }

  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('draftStates');

  setIsAuthenticated(false);
  setRole(null);
  setUser(null);
};

  useEffect(() => {
    let interval;
    if (isAuthenticated) {
      const pingHeartbeat = async () => {
        try {
          const token = localStorage.getItem('token');
          if (token) {
            await fetch(`${process.env.REACT_APP_BASE_API_URL}/api/heartbeat`, {
              method: 'POST',
              headers: { 'Authorization': `Bearer ${token}` }
            });
          }
        } catch (error) {
          console.error("Heartbeat failed", error);
        }
      };
      
      // Ping immediately and then every 5 minutes
      pingHeartbeat();
      interval = setInterval(pingHeartbeat, 5 * 60 * 1000);
    }
    return () => clearInterval(interval);
  }, [isAuthenticated]);

  return (
    <AuthContext.Provider value={{ isAuthenticated, role, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);